import { Avatar, Box, IconButton, Typography } from "@material-ui/core";
import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import useChatStyles from "./chatStyles";

const ChatTitle = ({userName, handleClose, avatarURL}: ChatTitleProps) => {
    const classes = useChatStyles({});

    return (
        <Box className={classes.dialogTitle}>
            <Box className={classes.title}>
                <Avatar className={classes.avatar} src={avatarURL} />
                <Typography variant="h5" className={classes.titleText}>{userName}</Typography>
            </Box> 
            <Box style={{margin: 5}}>
                <IconButton className={classes.exitButton} onClick={(event) => { handleClose(event)}} size={"medium"}>
                    <CloseIcon/>
                </IconButton>
            </Box>
        </Box>
    )
};
export default ChatTitle;

interface ChatTitleProps {
    userName: string|undefined;
    avatarURL: string|undefined;
    handleClose: (event:any) => void;
}